import { B2C } from "./B2C";

export const SecondSection = () => {
  return (
    <div className="flex flex-col whitespace-nowrap lg:flex-row">
      <B2C />
    </div>
  );
};
